import React from 'react';
import { Field } from 'redux-form';

import Fields from 'components/Fields';
import { useFormatMessage } from 'components/IntlProvider';

const ProductInfo = () => {
  const t = useFormatMessage();
  return (
    <>
      <Field
        component={Fields.Text}
        variant="outlined"
        margin="normal"
        fullWidth
        label={t('fields.wizard.brand.label', 'Product brand')}
        name="brand"
        placeholder={t(
          'fields.wizard.brand.placeholder',
          'Which brand is the product?'
        )}
        helperText={t(
          'fields.wizard.brand.helpertext',
          'Which brand is the product?'
        )}
        autoComplete="off"
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Field
        component={Fields.Text}
        variant="outlined"
        margin="normal"
        fullWidth
        label={t('fields.wizard.productname.label', 'Product Name')}
        name="name"
        placeholder={t(
          'fields.wizard.productname.placeholder',
          'ex. Chocolate Cream'
        )}
        helperText={t(
          'fields.wizard.productname.helpertext',
          'What is the full name of the product you want to test?'
        )}
        autoComplete="off"
        InputLabelProps={{
          shrink: true,
        }}
      />
    </>
  );
};

export default ProductInfo;
